export enum Category {
  POLITICIAN = 'politician',
  TEACHER = 'teacher',
  YOUTH = 'youth',
  PARTICIPATE = 'participate',
  OTHER = 'other',
}
